import { reactive, ref } from "vue"

export const myUser = reactive({})
export const tenant = reactive({})
export const tenantCompany = reactive({})
export const tenantUser = reactive({})
export const tenantCompanies = ref([])
// Tracks whether tenant memberships were successfully loaded (vs errored/unknown).
// Used by router guards to avoid treating API failures as "0 tenants".
export const tenantMembershipLoadState = reactive({
  status: "idle" // idle | loading | loaded | error
})
export const selectedTenantId = ref(null)
export const tenantSelectionState = reactive({
  visible: false,
  mode: "initial",
  resolver: null
})
export const userProfileCompletionState = reactive({
  visible: false,
  resolver: null
})

let userInitResolver = null
export let isUserInitialized = createUserInitPromise()

function createUserInitPromise() {
  return new Promise((resolve) => {
    userInitResolver = resolve
  })
}

export function resetAuthState() {
  Object.keys(tenant).forEach((key) => delete tenant[key])
  Object.keys(myUser).forEach((key) => delete myUser[key])
  Object.keys(tenantCompany).forEach((key) => delete tenantCompany[key])
  Object.keys(tenantUser).forEach((key) => delete tenantUser[key])
  tenantCompanies.value = []
  tenantMembershipLoadState.status = "idle"
  selectedTenantId.value = null
  tenantSelectionState.visible = false
  tenantSelectionState.mode = "initial"
  tenantSelectionState.resolver = null
  userProfileCompletionState.visible = false
  userProfileCompletionState.resolver = null

  isUserInitialized = createUserInitPromise()
}

export function markUserInitialized() {
  if (userInitResolver) {
    userInitResolver()
  }
}

export function setTenantCompanies(companies = []) {
  tenantCompanies.value = companies
}

export function setTenantMembershipLoadState(status = "idle") {
  tenantMembershipLoadState.status = status
}

export function requestTenantSelection(mode = "initial") {
  tenantSelectionState.visible = true
  tenantSelectionState.mode = mode
  return new Promise((resolve) => {
    tenantSelectionState.resolver = resolve
  })
}

export function resolveTenantSelection(tenantId) {
  selectedTenantId.value = tenantId
  tenantSelectionState.visible = false
  const resolver = tenantSelectionState.resolver
  tenantSelectionState.resolver = null
  if (resolver) {
    resolver(tenantId)
  }
}

export function requestUserProfileCompletion() {
  userProfileCompletionState.visible = true
  return new Promise((resolve) => {
    userProfileCompletionState.resolver = resolve
  })
}

export function resolveUserProfileCompletion() {
  userProfileCompletionState.visible = false
  const resolver = userProfileCompletionState.resolver
  userProfileCompletionState.resolver = null
  if (resolver) {
    resolver(true)
  }
}
